<template>
  <layout :session="session" :participant="participant">
    <div class="mt-20 items-center max-w-xl mx-auto px-12 py-5 text-left">

      <div class="border-t border-gray-400 mb-6"></div>

      <h1 class="text-[2.8rem] leading-[2.8rem] sm:text-5xl uppercase font-medium">
        Danke<br />fürs<br />Mitmachen.
      </h1>

      <div class="border-t border-gray-400 mt-16"></div>
    </div>
  </layout>
</template>


<script>
import Layout from '@/Pages/DiyWorkshop/Shared/Layout';

export default {
  components: {
    Layout
  },

  props: ['session', 'participant', 'translations'],

  created() {
    // Echo.channel('markencode-app.session.' + this.participant.markencode_session.id).here((users) => {
    //     console.log(users);
    // })
  },


  data() {
    return {
      sending: false
    };
  },

  methods: {}
};
</script>